import { ControllerType } from "@skydio/pbtypes/pbtypes/tools/cloud_api/enums_pb";

import { GamepadMode } from "state/pilot/types";

import type { ValueType } from "@skydio/core";

export const iconPath = (filename: string, darkBg = false) =>
  `/images/icons/${darkBg ? "dark_bg/" : ""}${filename}.svg`;

export const getControllerImagePath = (
  controllerType: ValueType<ControllerType.ControllerTypeEnumMap>
) => {
  const names = {
    [ControllerType.ControllerTypeEnum.UNKNOWN]: "/images/controllers/controller_c78.png", // default to C78 for unknown controller types
    [ControllerType.ControllerTypeEnum.C78]: "/images/controllers/controller_c78.png",
    [ControllerType.ControllerTypeEnum.C18]: "/images/controllers/controller_c18.png",
  };
  return names[controllerType];
};

export const getOfflineUpdateInstructionsPath = () => {
  return `/docs/Skydio_X2D_Offline_Update_Instructions.pdf`;
};

export const getGamepadImagePath = (
  gamepadMode: GamepadMode,
  boostModeEnabled: boolean,
  crawlModeEnabled: boolean
) => {
  const names = {
    [GamepadMode.MODE_1]: "gamepad-mode-1",
    [GamepadMode.MODE_2]: "gamepad-mode-2",
    [GamepadMode.MODE_3]: "gamepad-mode-3",
    [GamepadMode.VIDEO_GAME_MODE]: "gamepad-video-game-mode",
  };
  const baseFilename = names[gamepadMode];
  if (boostModeEnabled && crawlModeEnabled) {
    return `/images/gamepad/boost_and_crawl_mode/${baseFilename}.png`;
  } else if (boostModeEnabled) {
    return `/images/gamepad/boost_mode_only/${baseFilename}.png`;
  } else if (crawlModeEnabled) {
    return `/images/gamepad/crawl_mode_only/${baseFilename}.png`;
  } else {
    return `/images/gamepad/${baseFilename}.png`;
  }
};
